/**
 * 정렬 방향을 결정하는 함수
 * @param {boolean} sortDesc - 정렬 방향 (false인 경우에만 ASC, 나머지(undefined, null, true)는 DESC)
 * @returns {string} - "DESC" 또는 "ASC"
 */
export const getSortDirection = (sortDesc) => {
  return sortDesc === false ? 'ASC' : 'DESC';
};

/**
 * 정렬 방향을 API 요청에 맞게 변환하는 함수
 * @param {boolean} sortDesc - 정렬 방향
 * @returns {string} - "DESC" 또는 "ASC"
 */
export const getSortParam = (sortDesc) => {
  return getSortDirection(sortDesc);
};
